import { Role } from '@energybox/react-ui-library/dist/types';
import { UserPermission } from '../hooks/useGetUserPermission';

export const determineShouldShowSwitchLink = (
  userPermission: UserPermission
) => {
  if (
    userPermission.isGlobal === true ||
    userPermission.role === Role.MANAGER ||
    userPermission.role === Role.ADMIN
  ) {
    return true;
  }

  return false;
};
